var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSurveyLocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 7.75054V4.7503C4 3.75566 4.39509 2.80176 5.09835 2.09844C5.80161 1.39512 6.75544 1 7.75 1C8.74456 1 9.69839 1.39512 10.4017 2.09844C11.1049 2.80176 11.5 3.75566 11.5 4.7503V7.75054M2.5 7.75054H13C13.8284 7.75054 14.5 8.42217 14.5 9.25066V14.5011C14.5 15.3296 13.8284 16.0012 13 16.0012H2.5C1.67157 16.0012 1 15.3296 1 14.5011V9.25066C1 8.42217 1.67157 7.75054 2.5 7.75054Z",
    stroke: "#7E2340",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveyLocked);
export default __webpack_public_path__ + "static/media/survey-locked.2026d759b50dc05ba2e74a409bb62da6.svg";
export { ForwardRef as ReactComponent };